#import "../fragments/prospector-saved-filter-fragment.graphql"

mutation CreateFilter($input: FilterCreateInput!) {
    filterCreate(input: $input) {
        filter {
            ...ProspectorSavedFilterFragment
        }
    }
}
